<template>
    <div>
        <div class="page" v-if="!day_info.day_id">
            <el-button-group class="flex-box nopadding">
                <el-button size="small" icon="el-icon-refresh" @click="getInfo()">刷新</el-button>
            </el-button-group>
            <div class="page-bd">
                <div class="welcome-box flex-box col-center bg-f8">
                    <div class="flex-box-bd"></div>
                    <img class="img-60" :src="$config.imgUrlCom + 'logo200.png'"/>
                    <div class="welcome-text f-gray mg-top10">{{$t('wellcom')}}</div>
                    <div class="flex-box-bd"></div>
                    <div class="flex-box-bd"></div>
                </div>
            </div>
        </div>
        <myPage :show_header="false" :max_flag="true" v-else>
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" icon="el-icon-refresh" @click="getInfo()">刷新</el-button>
                </el-button-group>
            </div>
            <mySpViewData :info="day_info" :day_api="day_api" :day_goods="day_goods"></mySpViewData>
            <div class="mg-top20">
                <my-sub-title>近30日成功订单走势</my-sub-title>
                <myEcharsCol id="goods_amt_area" :rows="goods_amt_area.rows" :line_value_key="goods_amt_area.line_value_key"
                             :name_key="goods_amt_area.name_key" :value_key="goods_amt_area.value_key"></myEcharsCol>
            </div>
        </myPage>
    </div>
</template>

<script>
import mySpViewData from '../../components/mySpViewData'
import myEcharsCol from '../../components/myEcharsCol'
import {setMenuActiveName} from "../../utils/base";
    export default {
        name: "welcome",
        components:{
            mySpViewData,
            myEcharsCol
        },
        data:function(){
            return{
                day_info: {},
                day_api: {
                    value_key:'use_qty',
                    name_key:'api_cname',
                    rows: [],
                },
                day_goods: {
                    value_key:'order_qty',
                    name_key:'goods_cname',
                    rows: [],
                },
                goods_amt_area: {
                    value_key:'mv_goods_amt',
                    name_key:'date_no',
                    line_value_key:'avg_goods_amt',
                    rows: [],
                }
            }
        },
        computed: {
            welcome_reload: function () {
                return this.$store.state.baseData.welcome_reload;
            }
        },
        mounted: function(){
            this.$base.setMenuActiveName();
            this.getInfo();
        },
        methods: {
            getInfo: function(){
                this.$store.commit("setBaseData_welcomeReload", false);
                this.$base.showLoading();
                this.$request.sendPost("com/get-spview", {},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.day_info = data.day_info;
                        this.$nextTick(()=>{
                            this.day_api.rows = data.day_api;
                            this.day_goods.rows = data.day_goods;
                            this.goods_amt_area.rows = data.goods_amt_area;
                        });
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            }
        },
        watch:{
            welcome_reload(newVal,oldVal){
                if(newVal){
                    this.getInfo();
                }
            }
        }
    }
</script>

<style scoped>
    .welcome-box{
        position: absolute;
        top: 0;
        left:0;
        right: 0;
        bottom: 0;
        text-align: center;
        font-size: 22px;
        border-top-left-radius: 5px;
    }
    .welcome-img img{
        width: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/welcome/index.vue